import { render, staticRenderFns } from "./CarouselController.vue?vue&type=template&id=01da38f1&scoped=true"
import script from "./CarouselController.vue?vue&type=script&lang=js"
export * from "./CarouselController.vue?vue&type=script&lang=js"
import style0 from "./CarouselController.vue?vue&type=style&index=0&id=01da38f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da38f1",
  null
  
)

export default component.exports